var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0.0131836C51.3718 0.0131836 52.6874 0.558132 53.6574 1.52815C54.6275 2.49816 55.1724 3.81379 55.1724 5.1856V44.8408H94.8276C96.1994 44.8408 97.515 45.3857 98.485 46.3557C99.4551 47.3258 100 48.6414 100 50.0132C100 51.385 99.4551 52.7006 98.485 53.6706C97.515 54.6406 96.1994 55.1856 94.8276 55.1856H55.1724V94.8408C55.1724 96.2126 54.6275 97.5282 53.6574 98.4982C52.6874 99.4682 51.3718 100.013 50 100.013C48.6282 100.013 47.3126 99.4682 46.3426 98.4982C45.3725 97.5282 44.8276 96.2126 44.8276 94.8408V55.1856H5.17241C3.8006 55.1856 2.48498 54.6406 1.51496 53.6706C0.544949 52.7006 0 51.385 0 50.0132C0 48.6414 0.544949 47.3258 1.51496 46.3557C2.48498 45.3857 3.8006 44.8408 5.17241 44.8408H44.8276V5.1856C44.8276 3.81379 45.3725 2.49816 46.3426 1.52815C47.3126 0.558132 48.6282 0.0131836 50 0.0131836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e9f729556d7b0a30e2aa6ec85e7ca69b.svg";
export { ForwardRef as ReactComponent };